import React from 'react';
import SeoMetadata from '../components/Seo/SeoMetadata';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';
import TituloDeckTablonWpc from '../components/sections/DeckTablonWpc/TituloDeckTablonWpc';
import IntroDeckTablonWpc from '../components/sections/DeckTablonWpc/IntroDeckTablonWpc';
import CaracteristicasDeckTablonWpc from '../components/sections/DeckTablonWpc/CaracteristicasDeckTablonWpc';
import MaterialDeckTablonWpc from '../components/sections/DeckTablonWpc/MaterialDeckTablonWpc';
import ColoresDeckTablonWpc from '../components/sections/DeckTablonWpc/ColoresDeckTablonWpc';
import GaleriaDeckTablonWpc from '../components/sections/DeckTablonWpc/GaleriaDeckTablonWpc';
import FormularioContactoDeckTablonWpc from '../components/sections/DeckTablonWpc/FormularioContactoDeckTablonWpc';

const DeckTablonWpc = () => {
  return (
    <div>
      <SeoMetadata
        title="Deck Tablón WPC para Exteriores | Decototal"
        description="Encuentra deck tablón WPC para crear espacios exteriores funcionales y decorativos. Consulta sus características y cotiza tu proyecto."
        keywords="deck tablón WPC, tablón para exterior, deck sintético, piso WPC"
        path="/deck-tablon-wpc"
        image="/assets/img/productos/piso-deck-wpc/deck-tablon-wpc-01.png"
      />
      <Header />
      <TituloDeckTablonWpc />
      <MaterialDeckTablonWpc />
      <GaleriaDeckTablonWpc />
      <ColoresDeckTablonWpc />
      <CaracteristicasDeckTablonWpc />
      <FormularioContactoDeckTablonWpc />
      <Footer />
    </div>
  );
};

export default DeckTablonWpc;